import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { ServiceTypes } from 'common/common/constants/service-types';

export const ServiceHeaderTranslateTexts = {
  CAPACITY: 'agentListTab.headers.capacity',
  UNLIMITED: 'agentListTab.headers.unlimited',
  ASSIGNED: 'agentListTab.headers.assigned',
  IN_QUEUE: 'agentListTab.headers.inQueue',
  LIVE_CHAT: 'agentListTab.headers.chat',
  SMS: 'agentListTab.headers.sms',
  FACEBOOK_MESSENGER: 'agentListTab.headers.facebook',
  MESSAGING_APPS: 'agentListTab.headers.asyncMessage',
  EMAIL: 'agentListTab.headers.email',
  OMNI: 'agentListTab.headers.omni'
};

export const ColumnWidth = {
  SMALL: '275px',
  MEDIUM: '400px',
  LONG: '500px',
  EXTRA_LONG: '650px'
};

export interface ServiceColumn {
  workItemType: string;
  serviceType: ServiceTypes;
  title: string;
  baseWidth: string;
}

export const ServiceColumns: ServiceColumn[] = [
  {
    workItemType: WorkItemTypes.OMNI,
    serviceType: ServiceTypes.OMNI,
    title: ServiceHeaderTranslateTexts.OMNI,
    baseWidth: ColumnWidth.EXTRA_LONG
  },
  {
    workItemType: WorkItemTypes.CHAT,
    serviceType: ServiceTypes.CHATS,
    title: ServiceHeaderTranslateTexts.LIVE_CHAT,
    baseWidth: ColumnWidth.LONG
  },
  {
    workItemType: WorkItemTypes.SMS,
    serviceType: ServiceTypes.SMS,
    title: ServiceHeaderTranslateTexts.SMS,
    baseWidth: ColumnWidth.MEDIUM
  },
  {
    workItemType: WorkItemTypes.FACEBOOK,
    serviceType: ServiceTypes.FACEBOOK,
    title: ServiceHeaderTranslateTexts.FACEBOOK_MESSENGER,
    baseWidth: ColumnWidth.MEDIUM
  },
  {
    workItemType: WorkItemTypes.ASYNC_MESSAGE,
    serviceType: ServiceTypes.ASYNC_MESSAGE,
    title: ServiceHeaderTranslateTexts.MESSAGING_APPS,
    baseWidth: ColumnWidth.LONG
  },
  {
    workItemType: WorkItemTypes.EMAIL,
    serviceType: ServiceTypes.EMAILS,
    title: ServiceHeaderTranslateTexts.EMAIL,
    baseWidth: ColumnWidth.MEDIUM
  }
];

export const DepartmentNameColumn = {
  baseWidth: ColumnWidth.SMALL
};
